import React, { useState } from 'react';
import AdminExpensesTab from '../components/AdminExpensesTab';

const AdminExpenses = () => {
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState<'success' | 'error'>('success');

  const showMessage = (msg: string, type: 'success' | 'error' = 'success') => {
    setMessage(msg);
    setMessageType(type);
    setTimeout(() => setMessage(''), 3000);
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#f5f5f5', 
      fontFamily: 'system-ui, -apple-system, sans-serif',
      padding: '24px'
    }}>
      {/* Header */}
      <div style={{ marginBottom: '32px' }}>
        <h1 style={{ 
          margin: '0 0 8px 0', 
          fontSize: '32px', 
          fontWeight: '700', 
          color: '#1f2937' 
        }}>
          💰 Admin Expenses
        </h1>
        <p style={{ 
          margin: 0, 
          fontSize: '16px', 
          color: '#6b7280' 
        }}>
          Manage and approve expense submissions with split-screen view
        </p>
      </div>

      {/* Admin Expenses Tab Component */}
      <AdminExpensesTab onMessage={showMessage} />

      {/* Message Display */}
      {message && (
        <div style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          backgroundColor: messageType === 'success' ? '#10b981' : '#ef4444',
          color: 'white',
          padding: '12px 20px',
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: '500',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
          zIndex: 1000
        }}>
          {message}
        </div>
      )}
    </div>
  );
};

export default AdminExpenses;
